import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface OrderSheetProductLikeRequest {
  lineSheetProductId: number;
}

export interface OrderSheetProductLikeResponse {
  lineSheetProductId: number;
  isLiked: boolean;
}

export interface OrderSheetProductLikePathParameter {
  buyerId: number;
  orderSheetSetId: number;
}

// 좋아요는 (오더시트세트, 상품) 단위라 URL 이 세트까지만 내려간다.
export const addOrderSheetProductLikeKey: YWRKey<OrderSheetProductLikePathParameter> =
  {
    url: ({ buyerId, orderSheetSetId }) =>
      `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/product-likes`,
    method: "post",
  };

export const deleteOrderSheetProductLikeKey: YWRKey<OrderSheetProductLikePathParameter> =
  {
    url: ({ buyerId, orderSheetSetId }) =>
      `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/product-likes`,
    method: "delete",
  };

export function useAddOrderSheetProductLike() {
  const fetcher = useFetcher<
    OrderSheetProductLikeRequest,
    OrderSheetProductLikeResponse
  >();

  return useYWR(addOrderSheetProductLikeKey, fetcher);
}

export function useDeleteOrderSheetProductLike() {
  const fetcher = useFetcher<
    OrderSheetProductLikeRequest,
    OrderSheetProductLikeResponse
  >();

  return useYWR(deleteOrderSheetProductLikeKey, fetcher);
}
